import React from 'react';
import { Link } from 'react-router-dom';
import {
  Zap, ArrowLeftRight, Sliders, GitBranch, Network, AlertTriangle, Shield, GitMerge,
  LayoutGrid, BookOpen, Calculator,
} from 'lucide-react';
import { cn } from '@/lib/utils';

const ICON_MAP = {
  Zap, ArrowLeftRight, Sliders, GitBranch, Network, AlertTriangle, Shield, GitMerge,
};

const NAV_SECTIONS = [
  {
    label: 'Modules',
    items: [
      { id: 'foundation', label: 'M01 Foundation', route: '/foundation', icon: 'Zap', status: 'live' },
      { id: 'transformers', label: 'M02 Transformers', route: '/transformers', icon: 'ArrowLeftRight', status: 'live' },
      { id: 'per-unit', label: 'M03 Per-Unit Analysis', route: '/per-unit', icon: 'Sliders', status: 'live' },
      { id: 'symmetrical-components', label: 'M04 Sym. Components', route: '/symmetrical-components', icon: 'GitBranch', status: 'live' },
      { id: 'sequence-networks', label: 'M05 Sequence Networks', route: '/sequence-networks', icon: 'Network', status: 'live' },
      { id: 'fault-analysis', label: 'M06 Fault Analysis', route: '/fault-analysis', icon: 'AlertTriangle', status: 'soon' },
      { id: 'protection', label: 'M07 Protection', route: '/protection', icon: 'Shield', status: 'soon' },
      { id: 'distribution-design', label: 'M08 Distribution Design', route: '/distribution-design', icon: 'GitMerge', status: 'soon' },
    ],
  },
  {
    label: 'Resources',
    items: [
      { id: 'calculators', label: 'Calculators Hub', route: '/calculators', icon: null, IconEl: Calculator, status: null },
      { id: 'about', label: 'About / How to Use', route: '/about', icon: null, IconEl: BookOpen, status: null },
    ],
  },
];

const SidebarContent = ({ currentPath }) => (
  <nav data-testid="sidebar-nav" className="overflow-y-auto py-3">
    {NAV_SECTIONS.map((section) => (
      <div key={section.label} className="mb-4">
        <p className="px-4 py-2 text-[10px] font-semibold uppercase tracking-widest text-slate-400 dark:text-slate-600">
          {section.label}
        </p>
        {section.items.map((item) => {
          const IconEl = item.IconEl || ICON_MAP[item.icon] || Zap;
          const isActive = currentPath === item.route;
          return (
            <Link
              key={item.id}
              to={item.route}
              data-testid={`sidebar-link-${item.id}`}
              className={cn(
                'flex items-center gap-2.5 px-4 py-2 mx-2 rounded-md text-sm transition-colors duration-150',
                isActive
                  ? 'bg-teal-50 dark:bg-teal-900/20 text-teal-700 dark:text-teal-400 font-medium'
                  : 'text-slate-600 dark:text-slate-400 hover:text-slate-900 dark:hover:text-slate-200 hover:bg-slate-100 dark:hover:bg-slate-800'
              )}
            >
              <IconEl className="h-4 w-4 flex-shrink-0" />
              <span className="truncate">{item.label}</span>
              {item.status === 'live' && (
                <span className="ml-auto text-[9px] font-bold bg-teal-600 text-white px-1.5 py-0.5 rounded-full flex-shrink-0">
                  LIVE
                </span>
              )}
            </Link>
          );
        })}
      </div>
    ))}
  </nav>
);

export default SidebarContent;
